"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const StatusMessage_1 = __importDefault(require("./StatusMessage"));
const Serializer_1 = require("../../../Serializer");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class StatusMessageSerializerV2 extends Serializer_1.Serializer {
    toArray(statusMessage) {
        return [
            VERSION,
            TrackerMessage_1.default.TYPES.StatusMessage,
            statusMessage.requestId,
            statusMessage.status
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, status] = arr;
        return new StatusMessage_1.default({
            version, requestId, status
        });
    }
}
exports.default = StatusMessageSerializerV2;
TrackerMessage_1.default.registerSerializer(VERSION, TrackerMessage_1.default.TYPES.StatusMessage, new StatusMessageSerializerV2());
//# sourceMappingURL=StatusMessageSerializerV2.js.map